import type { DataRegion } from '../createInstance';

export const API_BASE_URLS: Record<DataRegion, string> = {
  us: 'https://api.engagespot.co/', // default
  eu: 'https://api-eu.engagespot.co/',
} as const;
